import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';

const AtlasV2PaidTrafficKeywordCountWithPaidTraffic = () => {
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const entityPhrase = useEntityPhrasing();
  const comparisonTimeDisplayName = useComparisonTimePeriodShortDisplayName();
  const taxonomyText = useTaxonomySubtitleText();

  return (
    <AtlasV2DorisSplineChart
      queryKey="paidTrafficKeywordCountSplineChart"
      title="Keyword Count with Paid Search Traffic"
      metricTypeDisplay={METRICTYPE.VOLUME}
      showLastWeekValue
      metricType="KeywordsWithPaidTrafficCount"
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`The chart displays the unique number of keywords that generated paid search traffic for ${entityPhrase} ${taxonomyText} during the 
                ${mainTimePeriodShortDisplayName} period compared to the ${comparisonTimeDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2PaidTrafficKeywordCountWithPaidTraffic;
